var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramFocusTabM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 68,
    viewBox: "0 0 57 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_14934)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_524_14934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.826 20L18.9459 14.2573L25.6403 9.99819L18.9459 5.74272L27.826 0L29.1757 2.08431L23.5452 5.72462L30.2685 9.99819L23.5452 14.2754L29.1757 17.9121L27.826 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2115 20L26.3279 14.2573L33.0259 9.99819L26.3279 5.74272L35.2115 0L36.5577 2.08431L30.9307 5.72462L37.6541 9.99819L30.9307 14.2754L36.5577 17.9121L35.2115 20Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_524_14934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.709 25.1494H23.7512V42.8468H26.709V25.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.77 25.1494H31.8123V42.8468H34.77V25.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1074 32.0114L24.754 34.8818L25.7092 37.701L34.0626 34.8305L33.1074 32.0114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3897 25.1729H10V28.1516H20.3897V25.1729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.676 26.6621H13.7183V42.8276H16.676V26.6621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6244 44L36.8169 33.3901L43.3239 24L45.7465 25.7021L40.4554 33.3381L47 42.2269L44.6244 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8123 31.877H38.6385V34.8557H45.8123V31.877Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_524_14934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4446 68L23.6364 57.3911L30.1416 48L32.5641 49.701L27.2771 57.339L33.82 66.2279L31.4446 68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95395 67.3318H0V51.653L7.20614 48.668L8.33033 51.4209L2.95395 53.6478V67.3318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15912 56.5967L0.869263 59.4668L2.08815 62.1773L8.378 59.3072L7.15912 56.5967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 67.3133L9.72729 58.2491L16.1056 48.6826L22.8084 57.8179L16.1667 67.3133ZM13.161 58.178L16.1573 62.5277L19.3418 57.8226L16.2185 53.852L13.161 58.1827V58.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4382 67.5116L48.6179 65.1614L52.7995 61.8778L47.5454 55.4291L54.3658 48.4023L56.4778 50.4872L51.5107 55.6044L56.9999 62.3469L50.4382 67.5116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3364 67.4122V48.5256H39.2904V62.9346L43.265 61.2525L43.0816 48.5446L46.0356 48.502L46.2472 63.2188L36.3364 67.4122Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_14934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_524_14934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7082,
    height: 20,
    fill: "white",
    transform: "translate(18.9459)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_524_14934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 20,
    fill: "white",
    transform: "translate(10 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_524_14934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 20,
    fill: "white",
    transform: "translate(0 48)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramFocusTabM);
export default __webpack_public_path__ + "static/media/programFocusTabM.041c252acd9b4632ebcb3b5b08fabae0.svg";
export { ForwardRef as ReactComponent };